import Big from 'big.js'

export const removeTrailingZeros = (value: string | number): string => {
  if (!value) return '0'

  const bigValue = new Big(value)

  const decimals = Math.max(0, bigValue.c.length - bigValue.e - 1)

  return bigValue.toFixed(decimals)
}
